<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/stores/app'
import { useResourcesStore } from '@/stores/resources'
import { useTr } from '@/composables/useTr'

const app = useAppStore()
const res = useResourcesStore()
const { tr } = useTr()

const targets = computed(() => res.viewTargets)

const byStatusZh = (s: string) => targets.value.filter((t) => t.status === s).length
const byTag = (tag: string) => targets.value.filter((t) => (t.tags || []).includes(tag)).length

const tags = ['bounty', 'immunefi', 'internal', 'client', 'osint', 'monitor']
</script>

<template>
  <aside class="targets-sub-nav">
    <div class="ssn-header">{{ tr('按状态', 'By Status') }}</div>
    <div class="ssn-item" :class="{ active: app.targetsFilter === 'all' }" @click="app.targetsFilter = 'all'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /></svg></span>
      <span style="flex:1;">{{ tr('全部', 'All') }}</span>
      <span class="badge num">{{ targets.length }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.targetsFilter === 'scanning' }" @click="app.targetsFilter = 'scanning'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-info); margin-right:2px;" />
      <span style="flex:1;">{{ tr('扫描中', 'Scanning') }}</span>
      <span class="badge num">{{ byStatusZh('扫描中') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.targetsFilter === 'idle' }" @click="app.targetsFilter = 'idle'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--text-faint); margin-right:2px;" />
      <span style="flex:1;">{{ tr('空闲', 'Idle') }}</span>
      <span class="badge num">{{ byStatusZh('空闲') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.targetsFilter === 'paused' }" @click="app.targetsFilter = 'paused'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-med); margin-right:2px; opacity:0.5;" />
      <span style="flex:1;">{{ tr('未启', 'Inactive') }}</span>
      <span class="badge num">{{ byStatusZh('未启') }}</span>
    </div>
    <div class="ssn-header" style="padding-top:14px;">{{ tr('按标签', 'By Tag') }}</div>
    <div
      v-for="tag in tags"
      :key="tag"
      class="ssn-item"
      :class="{ active: app.targetsFilter === tag }"
      @click="app.targetsFilter = tag"
    >
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" /><circle cx="7" cy="7" r="1.5" /></svg></span>
      <span style="flex:1;">{{ tag }}</span>
      <span class="badge num">{{ byTag(tag) }}</span>
    </div>
  </aside>
</template>
